import { Controller } from "@hotwired/stimulus"

// Живой счётчик длины для SEO-полей (Title / Description) в админке.
// Подсвечивает: зелёный — в приёмочном диапазоне [min, max], янтарный —
// короче min, красный — длиннее max. Диапазон задаётся data-value'ами.
//
// Разметка:
//   <div data-controller="char-counter"
//        data-char-counter-min-value="70"
//        data-char-counter-max-value="170">
//     <textarea data-char-counter-target="field"
//               data-action="input->char-counter#update"></textarea>
//     <p data-char-counter-target="count"></p>
//   </div>
export default class extends Controller {
  static targets = ["field", "count"]
  static values = { min: Number, max: Number }

  connect() {
    this.update()
  }

  update() {
    const len = this.fieldTarget.value.trim().length
    let cls = "text-emerald-600"
    let hint = "ок"
    if (len < this.minValue) {
      cls = "text-amber-600"
      hint = `коротко, минимум ${this.minValue}`
    } else if (len > this.maxValue) {
      cls = "text-red-600"
      hint = `длинно, максимум ${this.maxValue}`
    }
    this.countTarget.className = `mt-1 text-sm font-medium ${cls}`
    this.countTarget.textContent = `${len} симв. · норма ${this.minValue}–${this.maxValue} · ${hint}`
  }
}
